// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AmazonOutlinedSvg from "@fishx/icons-svg/es/asn/AmazonOutlined";
import FishxIcon from '../components/FishxIcon';

var AmazonOutlined = function AmazonOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AmazonOutlinedSvg
  }));
};

AmazonOutlined.displayName = 'AmazonOutlined';
export default React.forwardRef(AmazonOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AmazonOutlined.js
// module id = 1984
// module chunks = 0